import { Badge, Flex } from "@mantine/core"
import { useSelector } from "react-redux"
import { IGeneral } from "../../../store/General"
import { StatusBadge } from "./StatusBadge"

type SlaInfo = {
  slaBreached?: boolean
  breachSeverity?: "CRITICAL" | "HIGH" | "MEDIUM" | "LOW" | string | null
  breachedAt?: string | null
}

type Props = {
  code: string | null | undefined
  sla?: SlaInfo | null
}

const severityColor = (s: SlaInfo["breachSeverity"]): string => {
  switch (s) {
    case "CRITICAL": return "red"
    case "HIGH":     return "orange"
    case "MEDIUM":   return "yellow"
    default:         return "gray"
  }
}

export function DeliveryStatusBadge({ code, sla }: Props) {
  const deliveryNoteStatus = useSelector((s: { general: IGeneral }) => s.general.deliveryNoteStatus)
  const breached = !!sla?.slaBreached
  const breachTitle = sla?.breachedAt
    ? `SLA breached: ${new Date(sla.breachedAt).toLocaleString()}`
    : "SLA breached"
  return (
    <Flex direction="column" gap={2}>
      <StatusBadge code={code} catalog={deliveryNoteStatus} />
      {breached && (
        <Badge size="xs" radius="sm" variant="filled" color={severityColor(sla?.breachSeverity)} title={breachTitle}>
          SLA breach
        </Badge>
      )}
    </Flex>
  )
}
